import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../config";
import { authFetch } from "../utility/AuthFetch";

function MarksEntry() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);

  const [standard, setStandard] = useState("");
  const [standardList, setStandardList] = useState([]);
  const hasStandard = !!standard;

  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);
  const hasDivision = !!div;

  const [type, setType] = useState("");
  const hasType = !!type;

  const [examName, setExamName] = useState("");
  const [examNameList, setExamNameList] = useState([]);
  const hasExamName = !!examName;

  const [finYear, setFinYear] = useState("");
  const [finYearList, setFinYearList] = useState([]);
  const hasFinYear = !!finYear;

  const [maxMarks, setMaxMarks] = useState("");

  const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const hasSubject = !!subject;

  const [studentList, setStudentList] = useState([]);

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`,
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setLoader(true);
    setDiv("");
    setType("");
    setExamName("");
    setExamNameList([]);
    setSubject("");
    setSubjectList([]);
    if (standard === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`,
      );
      const result = await response.json();
      setDivList(result.division);
    } catch (error) {
      console.error("Error fetching division:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchExamName = async (type) => {
    setLoader(true);
    setExamName("");
    setExamNameList([]);
    setSubject("");
    setSubjectList([]);
    if (type === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/exam-category-options?query=${type}`,
      );
      const result = await response.json();
      setExamNameList(result.exam_categories);
    } catch (error) {
      console.error("Error fetching exam name:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchSubject = async () => {
    setLoader(true);
    setSubjectList([]);
    setSubject("");
    setStudentList([]);
    if (standard === "" || div === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/subject-options?standard=${standard}`,
      );
      const result = await response.json();
      setSubjectList(result.subjects);
    } catch (error) {
      console.error("Error fetching subject:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchFinYear = async () => {
    setLoader(true);
    setFinYearList([]);
    setFinYear("");
    setStudentList([]);
    try {
      const response = await authFetch(`${API_BASE_URL}/api/finYear`);
      const result = await response.json();
      setFinYearList(result.finYear);
    } catch (error) {
      console.error("Error fetching financial year:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchStudents = async (finYear) => {
    setLoader(true);
    if (finYear === "") return;
    if (type === "Internal Assessment") {
      setMaxMarks(
        examNameList.find((item) => item.id === Number(examName))?.maxMarks / 5,
      );
    } else {
      setMaxMarks(
        examNameList.find((item) => item.id === Number(examName))?.maxMarks,
      );
    }
    setStudentList([]);
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/student?standard=${standard}&div=${div}
              &name=${examName}&subject=${subject}&finYear=${finYear}`,
      );
      const result = await response.json();
      setStudentList(result.student);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleMarksChange = (index, value, col) => {
    const updated = [...studentList];
    if (col === "classWork") {
      updated[index].classWork = value;
    } else if (col === "homeWork") {
      updated[index].homeWork = value;
    } else if (col === "subEnrichment") {
      updated[index].subEnrichment = value;
    } else if (col === "discipline") {
      updated[index].discipline = value;
    } else if (col === "classInvolvement") {
      updated[index].classInvolvement = value;
    } else {
      updated[index].marks = value;
    }
    setStudentList(updated);
  };

  const normalizeMarkValue = (value) => {
    if (!isNaN(value)) return value;

    return value.toUpperCase();
  };

  const validateMarkOnBlur = (index, col) => {
    const updated = [...studentList];
    let value = updated[index][col];

    if (value === "" || value == null) {
      updated[index][col] = 0;
    }

    value = normalizeMarkValue(value);

    if (value === "AB") {
      updated[index][col] = "AB";
      setStudentList(updated);
      return;
    }

    const num = Number(value);

    if (isNaN(num) || num < 0 || num > maxMarks) {
      updated[index][col] = 0;
    } else {
      updated[index][col] = num;
    }

    setStudentList(updated);
  };

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    studentList.forEach((s, index) => {
      formData.append(`marks[${s.admission}]`, s.marks);
      formData.append(`classWork[${s.admission}]`, s.classWork);
      formData.append(`homeWork[${s.admission}]`, s.homeWork);
      formData.append(`subEnrichment[${s.admission}]`, s.subEnrichment);
      formData.append(`discipline[${s.admission}]`, s.discipline);
      formData.append(`classInvolvement[${s.admission}]`, s.classInvolvement);
    });

    const url = `${API_BASE_URL}/api/add-marks`;

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Marks added successfully");
        formRef.current.reset();
        setStandard("");
        setDiv("");
        setDivList([]);
        setType("");
        setExamName("");
        setExamNameList([]);
        setSubject("");
        setSubjectList([]);
        setFinYear("");
        setFinYearList([]);
        setIsSubmitting(false);
        setLoader(false);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Marks Entry</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="class"
                      required
                      value={standard}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Class
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {hasStandard && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>
                          Section <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          value={div}
                          onChange={(e) => {
                            setDiv(e.target.value);
                            setType("");
                          }}
                          required
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {hasDivision && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formType">
                            <Form.Label>
                              Exam Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="type"
                              value={type}
                              onChange={(e) => {
                                const value = e.target.value;
                                setType(value);
                                fetchExamName(value);
                              }}
                              required
                            >
                              <option value="" disabled>
                                Select Exam Type
                              </option>
                              <option value="Periodic Test">
                                Periodic Test
                              </option>
                              <option value="Internal Assessment">
                                Internal Assessment
                              </option>
                              <option value="Half Yearly">Half Yearly</option>
                              <option value="Annual Exam">Annual Exam</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        {hasType && (
                          <>
                            <Col md={4}>
                              <Form.Group className="mb-3" controlId="formType">
                                <Form.Label>
                                  Exam Name
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                  name="name"
                                  value={examName}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setExamName(value);
                                    fetchSubject();
                                  }}
                                  required
                                >
                                  <option value="" disabled>
                                    Select Exam
                                  </option>
                                  {examNameList?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            {hasExamName && (
                              <>
                                <Col md={4}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formType"
                                  >
                                    <Form.Label>
                                      Subject Name
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="subject"
                                      value={subject}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setSubject(value);
                                        fetchFinYear();
                                      }}
                                      required
                                    >
                                      <option value="" disabled>
                                        Select Subject
                                      </option>
                                      {subjectList?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.Name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {hasSubject && (
                                  <>
                                    <Col md={4}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formType"
                                      >
                                        <Form.Label>
                                          Financial Year
                                          <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                          name="finYear"
                                          value={finYear}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setFinYear(value);
                                            fetchStudents(value);
                                          }}
                                          required
                                        >
                                          <option value="" disabled>
                                            Select Financial Year
                                          </option>
                                          {finYearList?.map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.fyName}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>

                                    {hasFinYear && (
                                      <Table
                                        striped
                                        bordered
                                        hover
                                        id="marksTable"
                                      >
                                        <thead>
                                          <tr>
                                            <th>NAME</th>
                                            <th>ROLL No.</th>
                                            <th>ADMISSION No.</th>
                                            <th>MAX MARKS</th>
                                            {type === "Internal Assessment" ? (
                                              <>
                                                <th>CLASS WORK</th>
                                                <th>HOME WORK</th>
                                                <th>SUB ENRICHMENT</th>
                                                <th>DISCIPLINE</th>
                                                <th>CLASS INVOLVEMENT</th>
                                              </>
                                            ) : (
                                              <th>MARKS OBTAINED</th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {studentList?.map((item, index) => (
                                            <tr key={index}>
                                              <td>{item.name}</td>
                                              <td>{item.roll}</td>
                                              <td>{item.admission}</td>
                                              <td>{maxMarks}</td>
                                              {type ===
                                              "Internal Assessment" ? (
                                                <>
                                                  <td>
                                                    <Form.Control
                                                      type="text"
                                                      value={
                                                        item.remarks === "AB"
                                                          ? "AB"
                                                          : item.classWork
                                                      }
                                                      onChange={(e) => {
                                                        handleMarksChange(
                                                          index,
                                                          e.target.value,
                                                          "classWork",
                                                        );
                                                      }}
                                                      onBlur={() =>
                                                        validateMarkOnBlur(
                                                          index,
                                                          "classWork",
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Form.Control
                                                      type="text"
                                                      value={
                                                        item.remarks === "AB"
                                                          ? "AB"
                                                          : item.homeWork
                                                      }
                                                      onChange={(e) => {
                                                        handleMarksChange(
                                                          index,
                                                          e.target.value,
                                                          "homeWork",
                                                        );
                                                      }}
                                                      onBlur={() =>
                                                        validateMarkOnBlur(
                                                          index,
                                                          "homeWork",
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Form.Control
                                                      type="text"
                                                      value={
                                                        item.remarks === "AB"
                                                          ? "AB"
                                                          : item.subEnrichment
                                                      }
                                                      onChange={(e) => {
                                                        handleMarksChange(
                                                          index,
                                                          e.target.value,
                                                          "subEnrichment",
                                                        );
                                                      }}
                                                      onBlur={() =>
                                                        validateMarkOnBlur(
                                                          index,
                                                          "subEnrichment",
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Form.Control
                                                      type="text"
                                                      value={
                                                        item.remarks === "AB"
                                                          ? "AB"
                                                          : item.discipline
                                                      }
                                                      onChange={(e) => {
                                                        handleMarksChange(
                                                          index,
                                                          e.target.value,
                                                          "discipline",
                                                        );
                                                      }}
                                                      onBlur={() =>
                                                        validateMarkOnBlur(
                                                          index,
                                                          "discipline",
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Form.Control
                                                      type="text"
                                                      value={
                                                        item.remarks === "AB"
                                                          ? "AB"
                                                          : item.classInvolvement
                                                      }
                                                      onChange={(e) => {
                                                        handleMarksChange(
                                                          index,
                                                          e.target.value,
                                                          "classInvolvement",
                                                        );
                                                      }}
                                                      onBlur={() =>
                                                        validateMarkOnBlur(
                                                          index,
                                                          "classInvolvement",
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <td>
                                                  <Form.Control
                                                    type="text"
                                                    value={
                                                      item.remarks === "AB"
                                                        ? "AB"
                                                        : item.marks
                                                    }
                                                    onChange={(e) => {
                                                      handleMarksChange(
                                                        index,
                                                        e.target.value,
                                                        "marks",
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      validateMarkOnBlur(
                                                        index,
                                                        "marks",
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Row>

              {hasFinYear && (
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  SUBMIT
                </Button>
              )}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarksEntry;
